import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const FillShoppingCartIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.85294 9.27725H8.19865C8.56354 9.27725 8.85024 8.98187 8.85024 8.62567C8.85024 8.26078 8.56354 7.97405 8.19865 7.97405H5.85294C5.49674 7.97405 5.20135 8.26078 5.20135 8.62567C5.20135 8.98187 5.49674 9.27725 5.85294 9.27725ZM1.8826 5.56752C2.1693 5.18526 2.58631 4.93331 3.05546 4.86381C3.11627 4.85512 3.15971 4.85512 15.2098 4.84643L15.4096 2.49203C15.4356 2.19665 15.6528 1.96207 15.9482 1.90995L17.7032 1.60587C18.0507 1.54506 18.3982 1.77963 18.459 2.13583C18.5198 2.49203 18.2853 2.82217 17.9291 2.89167L16.6693 3.10887L15.8961 12.3006C15.8005 13.4214 14.8536 14.2988 13.7328 14.2988H4.49764C3.42035 14.2988 2.49944 13.4909 2.35174 12.4309L1.54377 6.88807C1.47427 6.41893 1.5959 5.94979 1.8826 5.56752Z"
        fill={props.fill || "currentColor" || "#224788"}
      />
      <path
        d="M14.3778 18.2612C13.7873 18.2612 13.3086 17.7824 13.3086 17.192C13.3086 16.6015 13.7873 16.1228 14.3778 16.1228C14.9683 16.1228 15.447 16.6015 15.447 17.192C15.447 17.7824 14.9683 18.2612 14.3778 18.2612Z"
        fill={props.fill || "currentColor" || "#224788"}
      />
      <path
        d="M4.80232 18.2629C5.01398 18.2629 5.22087 18.2002 5.39684 18.0826C5.57289 17.9649 5.71004 17.7978 5.79099 17.6022C5.87194 17.4066 5.89304 17.1914 5.8517 16.9837C5.81035 16.7762 5.70839 16.5855 5.55865 16.436C5.40891 16.2863 5.21809 16.1844 5.01051 16.1433C4.80284 16.1021 4.5877 16.1234 4.39219 16.2045C4.19668 16.2856 4.02957 16.4229 3.91214 16.599C3.79462 16.7751 3.732 16.9821 3.73218 17.1938C3.73244 17.4773 3.84526 17.7493 4.0459 17.9498C4.24653 18.1503 4.51865 18.2629 4.80232 18.2629Z"
        fill={props.fill || "currentColor" || "#224788"}
      />
    </svg>
  );
};

export default FillShoppingCartIcon;
